/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Top_Up_NoteInputs */

const cs_billing_top_up_note = /** @type {(inputs: Billing_Top_Up_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámka`)
};

const en_billing_top_up_note = /** @type {(inputs: Billing_Top_Up_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Billing_Top_Up_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_top_up_note = /** @type {((inputs?: Billing_Top_Up_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Top_Up_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_top_up_note(inputs)
	return cs_billing_top_up_note(inputs)
});